import { HoldingsStore } from '.';
import { RootState } from '../..';

export const selectHoldings = (state: RootState): HoldingsStore => state.holdings;
